/**
 * BGM の音源ファイルのアップロード (BgmSection のアップロードタブと、全編モーションの生成前モーダルで共用)。
 * 個人フォルダに source_type='bgm' で保存し、曲名 (拡張子を除いたファイル名) を generation_metadata に残す。
 * シナリオへの紐づけ (bgm_material_id) は呼び出し側が行う。
 */
import { updateTemporaryMaterial, uploadTemporaryMaterial } from '../../../features/materials/api';

/** BGM として受け付ける音源の accept 属性 (BgmSection と同じ) */
export const BGM_UPLOAD_ACCEPT = '.mp3,.wav,.aac,audio/mpeg,audio/wav,audio/aac';

export async function uploadBgmFile(
  file: File,
  opts?: { scenarioId?: string },
): Promise<{ materialId: string; name: string }> {
  const result = await uploadTemporaryMaterial({ file, source_type: 'bgm' });
  const materialId: string = result.id || ((result as { material_id?: string }).material_id ?? '');
  const name = file.name.replace(/\.[^.]+$/, '');
  try {
    await updateTemporaryMaterial(materialId, {
      generation_metadata: {
        ...(opts?.scenarioId ? { scenario_id: opts.scenarioId } : {}),
        filename: name,
        song_title: name,
      },
    });
  } catch { /* best-effort */ }
  return { materialId, name };
}
